<template lang="html">
    <div id="cultivate"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <navBar :tags="tags" :title="titleName" :subTitle="subTitle" :btnAdd="true" :btnBack="false"
                @btnAdd="handleAdd"  @btnBackClick="handleBackClick"/>
        <div style="width: 100%;height: 300px;border-bottom: 2px dotted rgb(231, 234, 236);">

            <el-row>
                <el-row style="position: relative;;margin-top: 10px">
                    <el-col :span="12" style="position: relative">
                        <span style="font-weight: bold;margin-right: 10px;width: 70px;display: inline-block">日期</span>
                        <div style="display: inline-block;width: calc(100% - 120px)">
                            <el-date-picker
                                    v-model="start_time"
                                    type="date"
                                    style="width: 45%"
                                    placeholder="选择日期"
                                    format="yyyy-M-d"
                                    value-format="yyyy-MM-dd"
                            >
                            </el-date-picker><span style="display: inline-block;
                        width: 10%;text-align: center">至
                            <!--     消除行内元素之间的空隙       -->
                    </span><el-date-picker
                                v-model="end_time"
                                type="date"
                                style="width: 45%"
                                placeholder="选择日期"
                                format="yyyy-M-d"
                                value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                        </div>
                    </el-col>
                    <div style="position: absolute;right: 0" v-if="this.role!='staff'">
                        <span style="line-height: 40px;font-weight: bold;margin-right: 10px">人员</span>
                        <el-select v-if="title !== '管理员'" v-model="selectPeople" clearable
                                   v-on:change="handleSelectInputClick"
                                   :disabled="title !== '管理员'"
                                   placeholder="" style="width: 160px">
                            <el-option v-for="(item,index) in options" :key="item.user_id"
                                       :label="item.user_name"
                                       :value="item.user_id">
                            </el-option>
                        </el-select>
                        <inputSelect :handleSelectInput="handleSelectInputClick" v-if="title === '管理员'"></inputSelect>
                    </div>
                </el-row>


                <el-col :span="12" style="margin-top: 20px">
                    <span style="margin-right: 10px;font-weight: bold;display: inline-block;width: 70px">类型</span>
                    <div style="display: inline-block;width: calc(100% - 120px)">
                        <el-select
                                style="width:45%"
                                v-model="affair_type"
                                clearable
                                @change="onTypeChange"
                                placeholder="选择类型">
                            <el-option
                                    v-for="item in options_duration"
                                    :key="item.key"
                                    :label="item.value1"
                                    :value="item.key">
                            </el-option>
                        </el-select>
                    </div>

                </el-col>
                <el-col style="line-height: 40px;margin-top: 20px">

                       <span  style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">状态
                        </span>
                    <el-checkbox-group style="display: inline-block" v-model="checkListArray" @change="ladderChange">
                        <el-checkbox  label="DRAFT">未提交</el-checkbox>
                        <el-checkbox  label="SUBMITTED">待审核</el-checkbox>
                        <el-checkbox  label="APPROVED">已批准</el-checkbox>
                        <el-checkbox  label="DENIED">已拒绝</el-checkbox>
                    </el-checkbox-group>
                </el-col>
            </el-row>
            <el-row style="margin-top:72px;">
                <el-button size="small" type="primary" @click.stop="searchWeekList">查询</el-button>
                <el-button size="small" type="danger" @click.stop="ResetClick">重置</el-button>
            </el-row>
        </div>

        <el-table
                :data="tableData"
                :header-cell-style="{'color':'black','font-size':'15px'}"
                border
                style="width: 100%;margin-top: 20px"
                stripe>
            <el-table-column
                    align="center"
                    fixed
                    type="index"
                    label="序号"
                    width="60">
            </el-table-column>
            <el-table-column
                    prop="start_time"
                    sortable
                    label="日期"
                    width="150"
            >
            </el-table-column>
            <el-table-column
                    width="80"
                    prop="activity_duration"
                    sortable
                    label="时长">
            </el-table-column>
            <el-table-column
                    width="110"
                    prop="affair_type_name"
                    sortable
                    label="类型">
            </el-table-column>
            <el-table-column
                    min-width="300"
                    prop="comments"
                    sortable
                    label="说明">
            </el-table-column>
            <el-table-column
                    width="90"
                    prop="confirmed_resultText"
                    label="状态"
                    sortable
            >
                <template slot-scope="scope">
                    <span  :style="{'color':scope.row.color}">{{scope.row.confirmed_resultText}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="90"
                    v-if="title === '管理员' && (GLOBAL.selectPeople_global === '' || GLOBAL.selectPeople_global === '0')"
                    prop="alias"
                    label="创建人"
                    sortable
            >
            </el-table-column>
            <el-table-column
                    fixed="right" label="操作"
                    width="80"
                    style="color: #3b99f7"
            >
                <template slot-scope="scope">
                    <el-button
                            type="warning" size="small"
                            @click="handleDetail(scope.row)">详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-col style="margin-bottom: 20px">
            <pagination :page="page" @changePage="changePageClick"></pagination>
        </el-col>
    </div>
</template>

<script>
    import navBar from '../../../components/navBar'
    import http from '../../../APIService/http'
    import pagination from '../../../components/pagination'
    import inputSelect from './components/inputSelect'
    import moment from 'moment'
    export default {
        name: "medical",
        data() {
            return {
                id: "",
                role:'',
                loading: false,
                tags: ['日程安排'],
                titleName:this.$store.getters.getUser.role ==='staff' ? this.$store.getters.getUser.alias:this.GLOBAL.peopleName_global,
                title:this.$store.getters.getUser.role ==='staff' ? this.$store.getters.getUser.alias:'管理员',
                subTitle: '公司会议/培训',
                options:[],
                tableData: [],
                value1: '',
                value2: '',
                selectPeople:this.$store.getters.getUser.user_id,
                selectPeopleManager:this.GLOBAL.selectPeople_global,
                page:this.GLOBAL.page_cultivate,
                start_time:'',
                end_time:'',
                options_province:[],
                options_city:[],
                province_name:'',
                city_name:'',
                affair_type:'',
                options_duration:[],
                checkListArray:[],
                searchForm:{}
            }
        },
        components: {
            navBar,
            pagination,
            inputSelect
            // Upload
        },
        created () {
            this.role = this.$store.getters.getUser.role
            this.getInternalType()
            this.getManager()
            this.init()
            // this.getCityData('province')
        },
        mounted () {
            // document.getElementById('main').scrollTo(0, 0)
        },
        methods: {
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.init()
            },
            handleDetail(row){
                row.titleName = this.titleName
                this.GLOBAL.page_cultivate = this.page
                this.searchForm = row
                this.$router.push({name:'train',params:row})
            },
            searchWeekList(){
                this.page= {
                    current: 1,
                    size: 5,
                    total: 0
                }
                this.init()
            },
            async getManager(){
                try {
                    let data={
                        user_id : this.$store.getters.getUser.user_id,
                        tenant_id : this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/Calendar/getManger',data).then(res=>{
                        this.options = res.data
                        let obj={
                            user_id : '',
                            user_name:'所有下属'
                        }
                        this.options.unshift(obj)
                    })
                } catch (e) {

                }
            },
            async init(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id : user.tenant_id,
                        user_id : user.user_id,
                        date : this.date,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        province_name:this.province_name,
                        city_name : this.city_name,
                        category : 'TRAINING',
                        affair_type: this.affair_type,
                        role : user.role,
                        checkListArray:this.checkListArray
                    }
                    if (this.start_time == '' || this.start_time == null){
                        data.start_time = ''
                    } else {
                        data.start_time=moment(this.start_time).format('YYYY-MM-DD')
                    }
                    if (this.end_time == '' || this.end_time == null){
                        data.end_time = ''
                    } else {
                        data.end_time=moment(this.end_time).format('YYYY-MM-DD')
                    }
                    if (user.role == 'staff') {
                        data.owner_id = this.selectPeople
                    }else {
                        data.owner_id = this.GLOBAL.selectPeople_global
                        if(this.GLOBAL.selectOu_global!=''){
                            data.owner_id =''
                            data.ou_id = this.GLOBAL.selectOu_global
                        }
                    }
                    await http.post('/wapi/InternalList/getInternalList',data).then(res=>{
                        // console.log(res)
                        if (res.success === true){
                            this.page.total = res.data.arrayCount.length
                            let traveArray = res.data.array
                            this.judeg(traveArray)

                            loading.close()
                        }
                    })
                }catch (e) {
                    loading.close()
                }
            },
            judeg(arr){
                let array = arr
                array.forEach((item,i)=>{

                    item.start_time = moment(item.activity_date).format('YYYY年M月D日')
                   if (item.activity_duration === 'FULLDAY'){
                       item.activity_duration = '全天'
                   } else if (item.activity_duration === 'FORENOON') {
                       item.activity_duration = '上午'
                   }else {
                       item.activity_duration = '下午'
                   }

                    if (item.status === 'SUBMITTED'){
                        item.confirmed_resultText = '待审核'
                        item.color = '#FF9901'
                    }
                    if (item.status === 'APPROVED'){
                        item.confirmed_resultText = '已批准'
                        item.color = 'green'
                    }
                    if (item.status === 'DENIED'){
                        item.confirmed_resultText = '已拒绝'
                        item.color = 'red'
                    }
                    if (item.status === 'DRAFT' || item.status === 'ACTIVE'){
                        item.confirmed_resultText = '未提交'
                        item.color = '#606266'
                    }

                    if (item.completed === 'T'){
                        item.confirmed_resultText = '已批准'
                        item.color = 'green'
                    }
                })
                this.tableData = array
            },
            async getInternalType(){
                let data={
                    category:''
                }

                data.tenant_id = this.$store.getters.getUser.tenant_id
                await http.post('/wapi/InternalList/getInternalType',data).then(res=>{
                    if (res.success == true){
                        this.options_duration = res.data
                    }
                })
            },
            handleSelectInputClick(j){
                for (let i=0;i<this.options.length;i++){

                    if (j === this.options[i].user_id){
                        this.titleName =this.options[i].user_name
                    }
                }
                this.GLOBAL.selectPeople_global = j
                this.titleName = this.GLOBAL.peopleName_global
                this.init()
            },
            handleAdd(){
                let row ={
                    type : 'new'
                }
                this.$router.push({name:'train',params:row})
            },
            async getCityData(type){
                // let data={
                //     type : type,
                //     province_id: type
                // }
                //
                // data.tenant_id = this.$store.getters.getUser.tenant_id
                // await http.post('/wapi/Evection/getProvinceList',data).then(res=>{
                //     if (res.success == true){
                //         console.log(res.data)
                //         if (data.type === 'province') {
                //             this.options_province = res.data
                //
                //         }else {
                //             this.options_city = res.data
                //         }
                //     }
                //
                // })
            },
            choseProvince(province_name){
                this.city_name = ''

                this.getCityData(province_name)
            },
            ResetClick(){
                this.affair_type = ''
                this.start_time = ''
                this.end_time = ''
                this.checkListArray=[]
            },
            ladderChange(){
                // if (this.checkListArray.length>1){
                //     this.checkListArray.shift()
                // }
            }
        },
        beforeRouteLeave(to, from, next){

            // 打开详情页（或者下一个任意界面）之前，把筛选条件保存到localStorage，如果离开列表页并且打开的不是详情页则清除，也可以选择不清除
            if (to.name === 'train' && to.params.type != 'new') {
                // console.log(this.searchForm)
                let condition = JSON.stringify(this.searchForm)
                localStorage.setItem('condition', condition)
            }else{
                localStorage.removeItem('condition')
            }
            if (to.name !== 'train'){
                this.GLOBAL.page_cultivate = {
                    current: 1,
                    size: 5,
                    total: 0
                }
            }
            next()
        }
    }
</script>

<style scoped>
    /*#container {*/
    /*    background: #fff;*/
    /*    padding: 0px 50px;*/
    /*    height: 100%;*/
    /*    box-sizing: border-box;*/
    /*}*/
    #cultivate >>>.el-form-item__label{
        font-size: 16px;
        color: #000000;
        padding-left: 0px;
        text-align: left;
        padding-right: 40px;
    }

    #cultivate >>>.el-table th{
        padding: 7px 0px;
    }
    #cultivate >>>.el-table td{
        padding: 7px 0px;
    }
    #cultivate >>> .el-button--warning {
        color: #FFF;
        background-color: #FF9901;
        border-color: #FF9901;
    }
    #cultivate >>> .el-button--warning:hover {
        background: #ebb563;
        border-color: #ebb563;
        color: #FFF;
    }
    #cultivate >>> tr th:nth-last-child(1) .cell {
        color: #2b92fa !important;
    }
    #cultivate >>> .el-button{
        font-size: 13px;
    }


</style>





// WEBPACK FOOTER //
// src/pages/calendar/components/cultivate.vue